
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M29.467 8.612l-7.359-7.358A.86.86 0 0021.497 1H5.144a.865.865 0 00-.865.865v30.27c0 .478.388.865.865.865h23.712a.865.865 0 00.865-.865V9.223c0-.23-.092-.45-.254-.611zm-1.755.69h-6.325V2.978l6.325 6.324zM6.009 31.27V2.73h13.648v7.438c0 .478.387.865.865.865h7.469V31.27H6.009z"}}),_c('path',{attrs:{"d":"M9.75 10.6h6.262a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm14.5 3.036H9.75a.431.431 0 100 .864h14.5a.432.432 0 000-.864zm-9.218 6.957v-.652h-4.714v.73h3.646l-3.707 5.365v.669h4.924v-.73h-3.869m5.091-6.033h.892v6.763h-.892zm5.017 0h-2.494v6.763h.892v-2.647h1.593c.765 0 1.353-.177 1.763-.532.41-.355.615-.861.615-1.516 0-.624-.209-1.123-.629-1.501-.421-.378-1-.567-1.74-.567zm1.096 3.048c-.254.225-.62.338-1.097.338h-1.603v-2.657h1.654c.443.008.791.134 1.046.376.253.242.381.565.381.968 0 .426-.127.751-.381.975z"}})])])
          )
        }
      }
    